<div class="course-hero__tags">
    <div class="course-tag course-tag--gold" *ngFor="let highlight of tags()">
      <!-- Top 5 tag -->
      <ng-template ngIf="highlight === 'Top-5'">
        <img src="/public/svgs/top-star.svg" alt="Top-5">
       <span class="course-tag__label">{{ highlight }}</span>
      </ng-template>
    </div>
  </div>